import { createFileRoute } from '@tanstack/react-router'
import { authClient } from '@/lib/auth'
import { requireAuth } from '@/lib/middleware'
import { Main } from '@/components/layout/main'
import { OrganizationProfilePage } from '@/features/organizations/settings/profile'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/profile'
)({
  beforeLoad: async () => {
    await requireAuth()
  },
  component: ProfilePage,
})

function ProfilePage() {
  const { data: activeOrganization, isPending } =
    authClient.useActiveOrganization()

  if (isPending) {
    return (
      <Main>
        <div className='py-8 text-center'>
          <p className='text-muted-foreground'>Loading organization...</p>
        </div>
      </Main>
    )
  }

  return <OrganizationProfilePage organizationId={activeOrganization?.id || ''} />
}
